// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1155":"976677ac","4746":"be940f8b","7247":"d4ea8c9b"}[chunkId] + ".chunk.css";
};